<script lang="ts" setup>
import { Database } from '@/models/database/Database'
import { Field } from '@/models/database/Field'
import { Node } from '@/models/database/Node'
import { NodeType } from '@/models/database/NodeType'
import { ref } from 'vue'
import { format } from 'date-fns'

interface Props {
  field: Field
  showLabel?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showLabel: true,
})

const model = ref()

function updatingModel() {

}

function onFieldChange() {

}

const proxyDate = ref(format(new Date(), 'dd/MM/yyyy'))

function save() {
  model.value = proxyDate.value
  props.field.value = proxyDate.value
  // emit('update:modelValue', model.value)
  // emit('update:field', props.node, props.field)
}
</script>

<template>
  <q-input v-model="model" class="q-pb-none" mask="##/##/####" v-bind="$attrs" @update:model-value="onFieldChange"
    :label="showLabel ? field.label : undefined">
    <template v-slot:prepend>
      <q-icon name="event" class="cursor-pointer"> </q-icon>
    </template>
    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
      <q-date v-model="proxyDate" mask="DD/MM/YYYY">
        <div class="row items-center justify-end">
          <q-btn v-close-popup label="Annuler" color="primary" flat />
          <q-btn v-close-popup label="OK" color="primary" @click="save" flat />
        </div>
      </q-date>
    </q-popup-proxy>
  </q-input>
</template>

<style lang="scss" scoped>
.table {
  margin-top: 10px;
}

h3 {
  font-size: medium;
}
</style>
